import React from 'react';
import { eventStopPropagation } from '../../App.helper';

const ActionPaddingWrapper = ({ children, moduleTable }) => (
  <span style={{ paddingLeft: moduleTable ? 0 : 24 }} onClick={(event) => eventStopPropagation({ event })}>{children}</span>
);

export default ActionPaddingWrapper;